<div class="container">
  <div class="d-flex justify-content-start flex-wrap emojiStyle">
    <div *ngFor="let item of to?.options">
      <div class="emoji-card me-2 mb-2" [ngClass]="{ 'selected-emoji': selectedValue === item?.value }"
        (click)="onClick(item)" *ngIf="item?.value !== 0; else skipBlock">
        <p class="mb-0 fs-4 text-center"> {{ item?.emoji }} </p>
        <p class="mb-0 text-primary-custom text-center small-label" [ngbTooltip]="item?.label" placement="bottom">
          {{ item?.label }}
        </p>
      </div>

      <ng-template #skipBlock>
        <div class="skipBtn" (click)="onClick(item)">
          <p class="text-primary-custom"> {{ item?.label }} </p>
        </div>
      </ng-template>
    </div>
  </div>
</div>